export default "__VITE_ASSET__fc632bd3__"